import { render, staticRenderFns } from "./DocResults.vue?vue&type=template&id=0ab5cfcb&"
import script from "./DocResults.vue?vue&type=script&lang=ts&"
export * from "./DocResults.vue?vue&type=script&lang=ts&"
import style0 from "./DocResults.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\koen\\workspace\\cf2\\src\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ab5cfcb')) {
      api.createRecord('0ab5cfcb', component.options)
    } else {
      api.reload('0ab5cfcb', component.options)
    }
    module.hot.accept("./DocResults.vue?vue&type=template&id=0ab5cfcb&", function () {
      api.rerender('0ab5cfcb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/search/results/table/DocResults.vue"
export default component.exports